// components/common/loading/LoadingIndicator/index.js
import LoadingIndicator from './loading_indicator';

export default LoadingIndicator;
